import { ServiceConfig } from '@user/store/services/config'
import type { ENTITY_TYPES } from '@sales-center/common'
import { IOption } from '@user/components/Filters'

export const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.activities.activities}`
export const urls = {
  fetchAll: (leadId: number, entityType: ENTITY_TYPES) =>
    `${baseUrl}/${entityType}/${leadId}`,
  delete: (id: number) => `${baseUrl}/${id}`,
  upsert: `${baseUrl}`,
  upsertBulk: `${baseUrl}/bulkAddToEntities`,
  updateStatus: `${baseUrl}/updatestatus`,
}

export enum ActivityStatus {
  Todo = 'Todo',
  InProgress = 'InProgress',
  Deferred = 'Deferred',
  Complete = 'Complete',
}

export const ActivityStatusOptions: IOption[] = [
  { label: 'To Do', value: 'Todo' },
  { label: 'In Progress', value: 'InProgress' },
  { label: 'Deferred', value: 'Deferred' },
  { label: 'Complete', value: 'Complete' },
]

export type ReminderThresholdValue =
  | 'None'
  | 'TimeOfEvent'
  | 'ThirtyMinsBeforeEvent'
  | 'OneHourBeforeEvent'
  | 'OneDayBeforeEvent'

export type EmailThresholdEntry = {
  name: string
  value: ReminderThresholdValue
}

export const emailThresholdEntries: EmailThresholdEntry[] = [
  { name: 'None', value: 'None' },
  { name: 'Time of event', value: 'TimeOfEvent' },
  { name: '30 min before event', value: 'ThirtyMinsBeforeEvent' },
  { name: '1 hour before event', value: 'OneHourBeforeEvent' },
  { name: '1 day before event', value: 'OneDayBeforeEvent' },
]

/**
 * Default length of an activity block, in minutes (SH-2133).
 *
 * Used both to seed Due from a calendar-click Start and to repair Due when an
 * edited Start passes it. Defined once because those two must agree: if they
 * drift, a click seeds a 30-minute block that silently resizes on the first
 * Start edit. It matches the grid snap granularity
 * (weekGeometry.SLOT_MINUTES), which is a separate constant because it is a
 * property of the grid geometry rather than of an activity.
 */
export const DEFAULT_ACTIVITY_MINUTES = 30
